import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Webinars from "@/pages/Webinars";

export const Route = createFileRoute("/zh-cn/webinars/")({
  head: () => buildRouteHead("/zh-cn/webinars"),
  component: Webinars,
});

